// utils/normalizeCommunities.ts
import { CommunitiesProps } from "../providers/types";


export const sortBySubDivision = (items: CommunitiesProps[]): CommunitiesProps[] =>
  [...items].sort((a, b) => a.subDivision.localeCompare(b.subDivision));

export const deduplicateByProjectId = (items: CommunitiesProps[]): CommunitiesProps[] => {
  const seen = new Set<number>();
  return items
    .filter((x) => {
      if (seen.has(x.projectId)) return false;
      seen.add(x.projectId);
      return true;
    })
    .sort((a, b) => a.subDivision.localeCompare(b.subDivision));
};

export const normalizeCommunities = (items: CommunitiesProps[]) => {
  const sorted = sortBySubDivision(items ?? []);
  const deduped = deduplicateByProjectId(sorted);
  return { sorted, deduped };
};